import React from 'react';

const headerLogoUrl = '/assets/brand/logo-app.webp';

export default function HeaderLogo({className = ''}) {
  return (
    <img
      src={headerLogoUrl}
      alt="Dojang Digital"
      className={`object-contain ${className}`}
    />
  );
}